import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import B2bElement from '../../../b2b-element.js';
import defaultStyle from "../../b2b-public-styles.scss";

@customElement('access-denied')
export class B2bAccessDenied extends B2bElement {
    static styles = [defaultStyle];

    render() {
        return html`
            <mta-page-title page-name="accessDenied" title="Access Denied"></mta-page-title>
            <div style="padding: 24px; display: flex; flex-direction: column; align-items: center;">
                <h1>Access denied. Please contact your Power User or MTA support team to request permission</h1>
            </div>
    `;
    }
}
